import { checkboxClasses as muiCheckboxClasses } from '@mui/material';
export * from './Checkbox';
export const checkboxClasses = muiCheckboxClasses;
